import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "101.5",
      cy: "202",
      rx: "34.1683",
      ry: "34",
      fill: "#FF9600"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.7411 203.377C20.7411 226.307 29.2164 245.761 44.2107 259.372C59.0472 272.839 79.1743 279.616 101.024 279.616C122.63 279.616 142.764 272.811 157.659 259.192C172.712 245.427 181.306 225.694 181.306 202.221C181.306 163.062 156.003 135.17 122.484 129.808L138.74 100.417C142.27 94.2015 143.764 88.0063 143.764 81.7978C143.764 61.3966 126.812 49.4538 110.554 49.4538C97.7882 49.4538 86.3865 56.3337 79.9383 68.3048C79.9373 68.3065 79.9364 68.3083 79.9354 68.3101L36.9446 147.944C27.0439 165.902 20.7411 183.349 20.7411 203.377ZM89.4721 203.665C89.4721 198.895 90.9933 195.829 92.6625 194.067C94.2623 192.378 96.8568 190.959 101.024 190.959C105.19 190.959 107.785 192.378 109.385 194.067C111.054 195.829 112.575 198.895 112.575 203.665C112.575 208.645 111.013 211.784 109.348 213.556C107.758 215.246 105.186 216.661 101.024 216.661C96.8612 216.661 94.2889 215.246 92.6996 213.556C91.0338 211.784 89.4721 208.645 89.4721 203.665Z",
      fill: "white",
      stroke: "#FF9600",
      "stroke-width": "28.8786"
    }, null, -1)
  ])))
}
export default { render: render }